function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "tick-icon");

var _ref2 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "1.75 9.37 7.62 16.08 18.25 3.92",
  fill: "none",
  stroke: "#53b260",
  strokeMiterlimit: 10,
  strokeWidth: 3
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/tick-icon.6a6ee78e.svg";
export { SvgComponent as ReactComponent };